import { render, staticRenderFns } from "./estimates-snapshot.vue?vue&type=template&id=2a2c07ac&scoped=true"
import script from "./estimates-snapshot.vue?vue&type=script&lang=js"
export * from "./estimates-snapshot.vue?vue&type=script&lang=js"
import style0 from "./estimates-snapshot.vue?vue&type=style&index=0&id=2a2c07ac&prod&lang=css"
import style1 from "./estimates-snapshot.vue?vue&type=style&index=1&id=2a2c07ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2c07ac",
  null
  
)

export default component.exports